<div class="ttmodal" style="min-width: 50vw;">
  <div class="ttmodal__header" style="margin-bottom: 15px">
    <span class="ttmodal__title"> {{'Alert'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <mat-tab-group>
    <mat-tab label=" {{'Alerts (Current)'| translate | async}}">
      <div style="overflow-y: auto; height:350px; ">
        <div class="d-flex justify-content-end align-items-center mb-2" style="float:right; padding:10px">
          <mat-checkbox [(ngModel)]="selectAll" (change)="toggleSelectAll($event)">
            Move All Alerts To History
          </mat-checkbox>
        </div>
         <div style="margin-left: 39%" *ngIf="loader">
            <mat-spinner></mat-spinner>
          </div>
        <table class="table table--striped table--full-width" *ngIf="!loader">
          <thead>
            <tr>
              <th> {{'Source'| translate | async}}</th>
              <th> {{'Created Date'| translate | async}}</th>
              <th> {{'Description'| translate | async}}</th>
              <th> {{'Link'| translate | async}}</th>
              <th> {{'Move to History'| translate | async}}</th>
            </tr>
          </thead>
          <ng-container *ngFor="let alert of userAlertslist">
            <tbody>
              <tr *ngIf="alert.status==1">
                <td style="cursor: pointer;">{{alert.Source}}</td>
                <td style="cursor: pointer;">{{alert.CreatedDate | date:'dd MMM yyyy'}}</td>
                <td style="cursor: pointer;">{{alert.description}} </td>
                <td style="cursor: pointer;" (click)="openNewWindow(alert.Link);">
                  <a> {{ alert.EquipmentName }}
                    <ng-container *ngIf="alert.FormName">
                      - {{ alert.FormName }}
                    </ng-container>
                  </a>
                </td>
                <td style="cursor: pointer;">
                  <mat-checkbox [checked]="alert.isHistory" (change)='checkboxChanged($event,alert.ID);'></mat-checkbox>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </mat-tab>
    <mat-tab label=" {{'Alert History'| translate | async}}">
      <div style="overflow-y: auto; height:350px; ">
        <table class="table table--striped table--full-width" *ngIf="!loader">
          <thead>
            <tr>
              <th style="text-align: center;"> {{'Source'| translate | async}}</th>
              <th style="text-align: center;"> {{'Created Date'| translate | async}}</th>
              <th style="text-align: center;"> {{'Description'| translate | async}}</th>
              <th style="text-align: center;"> {{'Link'| translate | async}}</th>
              <th style="text-align: center;"> {{'Move to Current'| translate | async}}</th>
            </tr>
          </thead>
          <ng-container *ngFor="let alert of userAlertslist">
            <tbody>
              <tr *ngIf="alert.status==2">

                <td style="text-align: center; cursor: pointer;">{{alert.Source}}</td>
                <td style="text-align: center; cursor: pointer;">{{alert.CreatedDate | date:'dd MMM yyyy'}}</td>
                <td style="text-align: center; cursor: pointer;">{{alert.description}} </td>
                <td style="text-align: center; cursor: pointer;" (click)="openNewWindow(alert.Link);">
                  <a>{{alert.EquipmentName}} - {{alert.FormName}}</a></td>
                <td style="text-align: center; cursor: pointer;">
                  <mat-checkbox [checked]="alert.isHistory" (change)='checkboxChanged($event,alert.ID);'></mat-checkbox>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
      <button class="button button--primary" (click)="ClearHistory()"><span class="button__text">Clear
          History</span></button>
    </mat-tab>
  </mat-tab-group>
</div>